import type { IWidget } from "app/components/widget/widget-types/Widget";
import {
    CURRENT_DASHBOARD_CHANGE_TITLE,
    CURRENT_DASHBOARD_CHECK_WIDGET_LOADED,
    CURRENT_DASHBOARD_INIT_DASHBOARD,
    CURRENT_DASHBOARD_IS_LOADING,
    CURRENT_DASHBOARD_RESET,
    CURRENT_DASHBOARD_WIDGET_ADDED,
    CURRENT_DASHBOARD_WIDGET_REMOVED,
    CURRENT_DASHBOARD_WIDGET_UPDATED,
} from "./CurrentDashboardActionTypes";

export const setDashboardInitialized = (
    dashboardId: string | null = null,
    widgets: IWidget<any>[],
    dashboardTitle: string | null = null,
) => {
    return {
        type: CURRENT_DASHBOARD_INIT_DASHBOARD,
        dashboardId,
        widgets,
        dashboardTitle,
    };
};

export const setWidgetUpdated = (widget: IWidget<any> | null = null) => {
    return {
        type: CURRENT_DASHBOARD_WIDGET_UPDATED,
        widget,
    };
};

export const resetDashboard = () => {
    return {
        type: CURRENT_DASHBOARD_RESET,
    };
};

export const checkWidgetsLoaded = () => {
    return {
        type: CURRENT_DASHBOARD_CHECK_WIDGET_LOADED,
    };
};

export const setWidgetAdded = (widget: IWidget<any>) => {
    return {
        type: CURRENT_DASHBOARD_WIDGET_ADDED,
        widget,
    };
};

export const setWidgetRemoved = (widget: IWidget<any>) => {
    return {
        type: CURRENT_DASHBOARD_WIDGET_REMOVED,
        widget,
    };
};

export const setDashboardTitle = (dashboardId: string, dashboardTitle: string) => {
    return {
        type: CURRENT_DASHBOARD_CHANGE_TITLE,
        dashboardId,
        dashboardTitle,
    };
};

export const setIsDashboardLoading = (isLoading: boolean) => {
    return {
        type: CURRENT_DASHBOARD_IS_LOADING,
        isLoading,
    };
};
